import { render, staticRenderFns } from "./CaseMenu.vue?vue&type=template&id=eeb373fa&scoped=true&"
import script from "./CaseMenu.vue?vue&type=script&lang=js&"
export * from "./CaseMenu.vue?vue&type=script&lang=js&"
import style0 from "./CaseMenu.vue?vue&type=style&index=0&id=eeb373fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb373fa",
  null
  
)

export default component.exports